export const BonusTypeComtrade = {
    Casino: 'Casino',
    Sportsbook: 'Sportsbook',
    External: 'External',
} as const;

export const BonusTypeBetler = {
    Bonus: 'bonus',
    ExternalToken: 'external_token',
    Token: 'token',
    Casino: 'Casino',
} as const;

export const BonusTypeNapoleon = {
    Cash: 'cash',
} as const;

export type BonusTypeBetler = typeof BonusTypeBetler[keyof typeof BonusTypeBetler];
export type BonusTypeComtrade = typeof BonusTypeComtrade[keyof typeof BonusTypeComtrade];
export type BonusTypeNapoleon = typeof BonusTypeNapoleon[keyof typeof BonusTypeNapoleon];

export type BonusTypeDto = BonusTypeComtrade | BonusTypeBetler | BonusTypeNapoleon;

export function isBetlerBonusType(bonus: BonusTypeDto): bonus is BonusTypeBetler {
    return Object.values<BonusTypeDto>(BonusTypeBetler).includes(bonus);
}

export function isComtradeBonusType(bonus: BonusTypeDto): bonus is BonusTypeComtrade {
    return Object.values<BonusTypeDto>(BonusTypeComtrade).includes(bonus);
}
